<div class="container-tabs">
    <div class="container-kpis">
        <mat-tree [dataSource]="params" [treeControl]="treeControl">
            <mat-tree-node *matTreeNodeDef="let node" matTreeNodeToggle>
                <div class="mat-tree-node">
                    <button mat-icon-button disabled></button>
                    <div class="object-container" style="justify-content: flex-start;">
                        <strong>{{node.Category_Desc}}</strong>
                        <div style="width: 100%; display: flex; justify-content: flex-end;">
                            <div class="container-node">
                                Categoria RS: <input class="space-node" type="text" placeholder="Nombre"
                                    [(ngModel)]="node.Category_RS" name="" id="">
                            </div>
                            <div class="container-node">
                                Descripción RS: <input class="space-node" type="text" placeholder="Descripción"
                                    [(ngModel)]="node.Category_Desc" name="" id="">
                            </div>
                            <button class="space" type="submit" (click)="updateRowNode(node)">Actualizar</button>
                        </div>
                    </div>
                </div>
            </mat-tree-node>
            <mat-nested-tree-node *matTreeNodeDef="let node; when: hasChild">
                <div>
                    <div class="mat-tree-node">
                        <button mat-icon-button matTreeNodeToggle>
                            <mat-icon class="mat-icon-rtl-mirror">
                                {{treeControl.isExpanded(node) ? 'expand_more' : 'chevron_right'}}
                            </mat-icon>
                        </button>
                        <div class="object-container" style="display: flex; justify-content: flex-start;">
                            <div style="display: flex; justify-content: space-between;width: 100%;">
                                <strong>{{ node.Category_Desc }}</strong>
                                <div class="container-main"
                                    style="display: flex; justify-content: flex-end; width: 100%;">
                                    <div class="container-node">
                                        Categoria RS: <input class="space-node" type="text" placeholder="Nombre"
                                            [(ngModel)]="node.Category_RS" name="" id="">
                                    </div>
                                    <div class="container-node">
                                        Descripción RS: <input class="space-node" type="text" placeholder="Descripción"
                                            [(ngModel)]="node.Category_Desc" name="" id="">
                                    </div>
                                    <button class="space" type="submit" (click)="updateRow(node)">Actualizar</button>
                                </div>
                            </div>
                        </div>
                    </div>
                    <ul [class.example-tree-invisible]="!treeControl.isExpanded(node)">
                        <ng-container matTreeNodeOutlet></ng-container>
                    </ul>
                </div>
            </mat-nested-tree-node>
        </mat-tree>
    </div>
</div>
